import { motion } from "framer-motion";
import { photoSrc } from "@/components/Reviews";

const label = (src = "") => {
  const name = src.split("/").pop().split(".")[0].replace(/[-_]+/g, " ").trim();
  return name && !/^[0-9a-f]{8,}/i.test(name) ? name.replace(/\b\w/g, (c) => c.toUpperCase()) : "";
};

export default function TourGalleryStrip({ images = [], title }) {
  if (!images.length) return null;
  return (
    <section className="py-8 border-b border-ink/10 bg-sand" data-testid="tour-gallery-strip">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-end justify-between gap-4 mb-4">
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-terra">Feel the trip</p>
          <h2 className="font-serif text-2xl sm:text-3xl font-bold text-ink mt-1">Places you'll actually stand in</h2>
        </div>
        <p className="hidden sm:block text-xs text-ink/50 font-mono">Swipe →</p>
      </div>
      <div className="flex gap-3 sm:gap-4 overflow-x-auto snap-x snap-mandatory px-4 sm:px-6 lg:px-8 pb-2 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" data-testid="tour-gallery-track">
        {images.map((src, i) => (
          <motion.figure key={src + i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: Math.min(i, 4) * 0.06 }}
            className="relative snap-start shrink-0 w-[74vw] sm:w-[360px] aspect-[4/3] rounded-2xl overflow-hidden bg-ink/5" data-testid={`tour-gallery-item-${i + 1}`}>
            <img src={photoSrc(src)} alt={label(src) || `${title} ${i + 1}`} loading={i < 2 ? "eager" : "lazy"} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
            {label(src) && <figcaption className="absolute bottom-3 left-3 bg-white/90 backdrop-blur text-ink text-xs font-semibold px-3 py-1.5 rounded-full">{label(src)}</figcaption>}
          </motion.figure>
        ))}
      </div>
    </section>
  );
}
